export class HookBasic {
  username: string;
  password: string;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}
